import React, { useId, useLayoutEffect, useRef } from 'react';

export function SidebarConfirm({ text, confirmText = 'Confirm', onConfirm, onClose }) {
  const dialogRef = useRef(null);
  const textId = useId();
  // A press that starts on the content and ends past the edge lands its click on the backdrop, and
  // is not a dismissal
  const pressedContent = useRef(false);

  useLayoutEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    dialog.focus();
    return () => {
      if (dialog.open) dialog.close();
    };
  }, []);

  // Closed before the caller runs, so the control it hands focus back to is no longer inert
  const dismiss = () => {
    dialogRef.current?.close();
    onClose();
  };

  return (
    <dialog
      ref={dialogRef}
      className="vs vs-confirm"
      tabIndex={-1}
      aria-labelledby={textId}
      onCancel={(event) => {
        if (event.target !== event.currentTarget) return;
        event.preventDefault();
        dismiss();
      }}
      onPointerDown={(event) => {
        pressedContent.current = event.target !== event.currentTarget;
      }}
      onClick={(event) => {
        if (event.target !== event.currentTarget || pressedContent.current) return;
        const rect = event.currentTarget.getBoundingClientRect();
        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        ) {
          dismiss();
        }
      }}
    >
      <div className="vs-confirm-content">
        <p id={textId} className="vs-confirm-text">{text}</p>
        <div className="vs-confirm-actions">
          <button type="button" className="vs-confirm-action" onClick={dismiss}>
            Cancel
          </button>
          <button
            type="button"
            className="vs-confirm-action is-danger"
            onClick={() => {
              onConfirm();
              dismiss();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </dialog>
  );
}
